<template>
  <div class="history">
    <fixed-header title="浏览历史"></fixed-header>
    <div
        v-infinite-scroll="loadMore"
        :infinite-scroll-disabled="loading"
        :infinite-scroll-distance="30"
        class="history__main scroll-touch"
    >
      <div v-if="!nowData" class="history__null">暂无浏览历史</div>
      <div
          v-for="(item, index) in nowData"
          v-else
          :key="index"
          class="history__item"
      >
        <div class="history__item-date">{{ item.title }}</div>
        <div
            v-for="(ele, index2) in item.log"
            :key="index2"
            :class="[
            'history__item-goods',
            index2 === item.log.length - 1 ? 'no_border' : ''
          ]"
            @click="gotoDetail(ele.goodsId)"
        >
          <img
              :mg-stat-lob="'smod=1&goods_id=' + ele.goodsId + '&stype=2'"
              :src="ele.goodsImage"
              alt=""
              mg-stat-show="flag=200"
          />
          <div>
            <p>{{ ele.goodsName }}</p>
            <p>￥{{ ele.shopPrice }}</p>
          </div>
        </div>
      </div>
      <page-loading v-if="loading"></page-loading>
    </div>
  </div>
</template>
<script>
import FixedHeader from 'components/common/FixedHeader';
import PageLoading from 'components/common/PageLoading';
import * as userApi from 'apis/user';
import _ from 'lodash';

export default {
  components: { FixedHeader, PageLoading },
  data() {
    return {
      nowData: [],
      loading: false,
      pageNo: 0,
      disableLoad: false,
      visitPage: null,
    };
  },
  methods: {
    /* 页面初始化就会自动执行该方法 */
    loadMore() {
      if (this.visitPage === this.pageNo) {
        return;
      }
      this.pageNo += 1;
      this.fetchHistory();
    },
    async fetchHistory() {
      this.loading = true;
      try {
        const { visitList, visitPage } = await userApi.getBrowHistory({
          p: this.pageNo,
        });
        const list = this.handleVisit(visitList);
        this.visitPage = visitPage;
        this.nowData.push(...list);
      } catch (error) {
        this.$toast('获取数据失败');
      }
      this.loading = false;
    },
    gotoDetail(id) {
      this.$router.push({ path: '/goods/detail', query: { id, showBack: 1 } });
    },
    handleVisit(list) {
      if (!_.isEmpty(list)) {
        const arr = [];
        Object.keys(list).forEach((key) => {
          arr.push({
            title: key,
            log: list[key],
          });
        });
        return arr;
      }
      return [];
    },
  },
};
</script>
<style lang="scss">
.history {
  height: 100%;
  box-sizing: border-box;

  &__main {
    height: 100%;
  }

  &__null {
    font-size: 30px;
    margin-top: 200px;
    text-align: center;
  }

  &__item {
    margin: 30px;
    padding: 0 30px;
    background: #ffffff;
    border-radius: 20px;

    &-date {
      padding-top: 15px;
      font-size: 24px;
      color: #9b9b9b;
    }

    &-goods {
      padding: 30px 0;
      display: flex;
      border-bottom: 2px solid rgba(211, 211, 211, 0.5);

      img {
        max-width: 136px;
        height: 136px;
        margin-right: 27px;
      }

      div {
        flex: 1;

        p:first-child {
          font-size: 28px;
          margin-bottom: 15px;
        }

        p:last-child {
          font-size: 32px;
          color: #ff4c00;
          font-weight: 600;
        }
      }
    }
  }

  .no_border {
    border: none;
  }
}
</style>

